import {Disclosure} from "@headlessui/react";
import cx from "classnames";
import {ChevronUpIcon} from "@heroicons/react/16/solid";
import {formatDateUTC} from "../../../utils/lib";
import {useQuery} from "@tanstack/react-query";
import {InvoiceApi} from "../../../api";
import {useParams} from "react-router-dom";
import {useProfile, useTimezone} from "../../../hooks";

export const InvoiceTransactions = () => {
    const profile = useProfile();
    const timezone = useTimezone();
    const {id} = useParams();
    const isTransactionsVisible = profile?.permissions.includes('invoice.transaction.read');

    const {data: transactions} = useQuery({
        queryKey: [InvoiceApi.KEY, 'getTransactions', id],
        queryFn: () => InvoiceApi.getTransactions(id!),
        enabled: isTransactionsVisible && !!id,
    });

    if (!isTransactionsVisible) return null

    return (
        <Disclosure>
            {({open}) => (
                <div className={cx(
                    'p-7 w-3/5 bg-white rounded-3xl',
                )}>
                    <Disclosure.Button
                        as={'h2'}
                        className={
                            cx(
                                'flex justify-between text-sm uppercase text-brand-6 font-semibold cursor-pointer',
                                'text-green-500',
                                open && 'mb-5',
                            )}
                    >
                        <span>Transactions ({transactions?.length})</span>
                        <ChevronUpIcon
                            className={cx(
                                open ? 'rotate-180 transform' : '',
                                'text-green-500',
                                'h-5 w-5',
                            )}
                        />
                    </Disclosure.Button>
                    <Disclosure.Panel className="grid gap-4">
                        <table
                            className="min-w-full text-sm font-light text-surface w-5/5">
                            <thead className="border-b border-neutral-200 font-medium">
                            <tr>
                                <th scope="col" className="pb-5 uppercase text-start">Id</th>
                                <th scope="col" className="pb-5 uppercase text-start">Provider Tx Id</th>
                                <th scope="col" className="pb-5 uppercase text-start">Status</th>
                                <th scope="col" className="pb-5 uppercase text-start">Create date</th>
                                <th scope="col" className="pb-5 uppercase text-start">Status date</th>
                            </tr>
                            </thead>
                            <tbody>
                            {transactions && transactions.length
                                ? transactions.map(transaction => {
                                    return (
                                        <tr className="h-12">
                                            <td>{transaction.id}</td>
                                            <td>{transaction.providerTxId}</td>
                                            <td>{transaction.status}</td>
                                            <td>{formatDateUTC(transaction.createDate, 'long', timezone)}</td>
                                            <td>{formatDateUTC(transaction.statusDate, 'long', timezone)}</td>
                                        </tr>
                                    );
                                })
                                : (
                                    <div className="grid gap-4 text-xs">
                                        <hr className="border-slate-100"/>
                                        <span className="w-full text-brand-2 m-0">No transactions</span>
                                    </div>
                                )}
                            </tbody>
                        </table>
                    </Disclosure.Panel>
                </div>
            )}
        </Disclosure>
    )
}